import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkipLinksComponent } from './skip-links.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [SkipLinksComponent],
  exports: [SkipLinksComponent]
})
export class SkipLinksModule {}
